export default __webpack_public_path__ + "static/EverydayInformation-7e20a83785923a9613cdc7698796b599.webp";